var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncomingVideoCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 15.382C24 16.1253 23.2177 16.6088 22.5528 16.2764L18.5528 14.2764C18.214 14.107 18 13.7607 18 13.382V9.61803C18 9.23926 18.214 8.893 18.5528 8.72361L22.5528 6.72361C23.2177 6.39116 24 6.87465 24 7.61803V15.382Z",
    fill: "#808080",
    stroke: "#808080",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 7C1 5.89543 1.89543 5 3 5H14C15.1046 5 16 5.89543 16 7V16C16 17.1046 15.1046 18 14 18H3C1.89543 18 1 17.1046 1 16V7ZM4.82817 13.0606L4.8391 8.57487C4.84011 8.16066 4.50514 7.82406 4.09093 7.82305C3.67672 7.82204 3.34012 8.157 3.33911 8.57122L3.32484 14.4243C3.09557 14.7059 3.09898 15.1202 3.34935 15.3987C3.38126 15.4342 3.41578 15.4659 3.45236 15.4939C3.58692 15.692 3.81385 15.8224 4.07143 15.823L10.5714 15.8389C10.9856 15.8399 11.3222 15.5049 11.3232 15.0907C11.3242 14.6765 10.9893 14.3399 10.5751 14.3389L5.66326 14.3269L11.7702 8.8364C12.0782 8.55946 12.1034 8.08526 11.8265 7.77723C11.5496 7.46921 11.0754 7.444 10.7673 7.72093L4.82817 13.0606Z",
    fill: "#808080"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomingVideoCall);
export default __webpack_public_path__ + "static/media/incoming-video-call.37a9f84949f9b8819d9b8f5b07389fba.svg";
export { ForwardRef as ReactComponent };